/**
 * Enumeration of the different delta operation types
 */ export var DeltaType = /*#__PURE__*/ function(DeltaType) {
    /** Create a new entity */ DeltaType[DeltaType["Create"] = 0] = "Create";
    /** Update an existing entity */ DeltaType[DeltaType["Update"] = 1] = "Update";
    /** Delete an existing entity */ DeltaType[DeltaType["Delete"] = 2] = "Delete";
    return DeltaType;
}({});
